import constants from './LoaderConstants';

const initialState = {
    loading: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
    case constants.START_LOADING: {
        return Object.assign({}, state, { loading: true });
    }
    case constants.END_LOADING: {
        return Object.assign({}, state, { loading: false });
    }
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/Loader/LoaderReducer.js